import { render, staticRenderFns } from "./ydym.vue?vue&type=template&id=a89c6ddc&scoped=true"
import script from "./ydym.vue?vue&type=script&lang=js"
export * from "./ydym.vue?vue&type=script&lang=js"
import style0 from "./ydym.vue?vue&type=style&index=0&id=a89c6ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89c6ddc",
  null
  
)

export default component.exports